/* Sniff and Shift free shipping meter.
   Appears 60 seconds into the visit, reads the real cart, and shows progress
   toward the $50 free shipping threshold. Updates when the cart changes.
   Dismissal is remembered for the browser session. */
(function () {
  var THRESHOLD_CENTS = 5000; /* $50 */
  var DELAY_MS = 60000;       /* 1 minute */
  var el, fill, text;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function render(totalCents) {
    if (!el) return;
    var remaining = Math.max(0, THRESHOLD_CENTS - totalCents);
    var pct = Math.min(100, Math.round((totalCents / THRESHOLD_CENTS) * 100));
    fill.style.width = pct + '%';
    if (remaining <= 0) {
      el.classList.add('sns-ship--unlocked');
      text.innerHTML = '<strong>Free shipping unlocked!</strong> This order ships free.';
    } else if (totalCents <= 0) {
      el.classList.remove('sns-ship--unlocked');
      text.innerHTML = 'Free shipping on orders $50+. Add <strong>' + money(remaining) + '</strong> to unlock it.';
    } else {
      el.classList.remove('sns-ship--unlocked');
      text.innerHTML = 'You are only <strong>' + money(remaining) + '</strong> away from free shipping.';
    }
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price || 0); })
      .catch(function () {});
  }

  function show() {
    if (!el || sessionStorage.getItem('sns-ship-dismissed')) return;
    refresh();
    el.classList.add('sns-ship--visible');
  }

  function init() {
    el = document.getElementById('sns-ship');
    if (!el) return;
    fill = el.querySelector('.sns-ship__fill');
    text = el.querySelector('.sns-ship__text');

    el.querySelector('.sns-ship__close').addEventListener('click', function () {
      el.classList.remove('sns-ship--visible');
      try { sessionStorage.setItem('sns-ship-dismissed', '1'); } catch (e) {}
    });

    setTimeout(show, DELAY_MS);

    /* Refresh after any add-to-cart interaction and periodically while open */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[name="add"], .quick-add__submit, button[type="submit"][form]')) {
        setTimeout(refresh, 1800);
      }
    });
    setInterval(function () {
      if (el.classList.contains('sns-ship--visible')) refresh();
    }, 45000);

    /* Exposed for testing and for other scripts */
    window.SNSShip = { show: show, refresh: refresh };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
